var Theme = Theme || {};

Theme.NewAndPopular = (function ($) {
    return {
        init: _init
    };

    function _init() {
        registerArticleListNewAndPopularCombinedMode();
    }

    function registerArticleListNewAndPopularCombinedMode () {
        $('.js-new-and-popular-mode').each(function () {
            var $linkNewAndPopularMode = $(this);

            $linkNewAndPopularMode.on('click', function (e) {
                var mode = $linkNewAndPopularMode.data('mode');
                var instanceName = $linkNewAndPopularMode.data('instancename');
                var $articleListNewPopContent = $('.js-new-and-popular-content-' + mode);

                e.preventDefault();
                $('.js-new-and-popular-mode').removeClass('active');
                $linkNewAndPopularMode.addClass('active');

                if (!$articleListNewPopContent.hasClass('hasContent')) {
                    _getArticleListNewAndPopularContent(mode, $articleListNewPopContent, instanceName);
                    $articleListNewPopContent.addClass('hasContent');
                }

                $('.js-new-and-popular-content').addClass('hide');
                $articleListNewPopContent.removeClass('hide');
            });
        });
    }

    function _getArticleListNewAndPopularContent(mode, $articleListNewPopContent, instanceName) {
        var ajaxUrl = (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + '/PlatformArticle/ArticleListNewAndPopularContent/' + instanceName;
        const $spinner = $articleListNewPopContent.siblings('.spinner');
        $spinner.removeClass('hide');
        SCM.Ajax.get(ajaxUrl, { mode: mode })
            .expectHtml()
            .then(function (data) {
                $articleListNewPopContent.html(data);
                $spinner.addClass('hide');
            })
            .catch(function (error) {
                console.error(error);
                $spinner.addClass('hide');
            });
    }

})(jQuery);